/**
 * 화면 언어 자체 관리 — 2026-11-05 Weglot → 자체 번역 전환 3단계.
 *
 * Weglot 이 있으면(지금 기본) 언어는 Weglot 이 정하고 이 모듈은 거의 아무것도 안 한다. Weglot 을 끈 상태(주소 끝에 ?weglot=off, 아래)에서는
 * 고른 언어를 브라우저 저장소(blb-lang)에 두고 <html lang> 에 건 뒤 'blb-lang-change' 를 알린다 — 사전 번역(uiDictionary)과 useLang 이 그것을 따른다.
 *
 * 시험 스위치: 주소에 ?weglot=off 를 붙여 한 번 열면 그 브라우저는 Weglot 없이 뜬다(blb-weglot=off 저장). ?weglot=on 으로 되돌린다.
 * 왜 스위치부터: 실제 화면에서 Weglot 없이도 괜찮은지 눈으로 확인한 뒤에 스크립트를 지운다(되돌릴 수 없는 일을 한 번에 하지 않으려고).
 */
export const OWN_LANGS = ['ko', 'en', 'th', 'vi'];
export const LANG_KEY = 'blb-lang';
export const WEGLOT_OFF_KEY = 'blb-weglot';
export const LANG_EVENT = 'blb-lang-change';

const get = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
const set = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* 저장소를 못 써도 이번 화면에서는 동작 */ } };

/** Weglot 을 끈 채로 열었나 */
export const isWeglotOff = () => get(WEGLOT_OFF_KEY) === 'off' || (typeof window !== 'undefined' && window.__blbWeglotOff === true);

/** 저장해 둔 언어(자체 저장 → 예전 Weglot 이 남긴 wglang), 없으면 null */
export function readOwnLang() {
  const own = get(LANG_KEY);
  if (OWN_LANGS.includes(own)) return own;
  const wg = get('wglang');
  return OWN_LANGS.includes(wg) ? wg : null;
}

/** 처음 열었을 때 언어 — 저장값, 없으면 브라우저 언어가 영·태·베일 때 그것, 아니면 한국어(Weglot auto_switch 와 같은 동작) */
export function initialOwnLang(navLang) {
  const saved = readOwnLang();
  if (saved) return saved;
  const nav = String(navLang ?? (typeof navigator !== 'undefined' ? navigator.language : 'ko') ?? 'ko').slice(0, 2);
  return ['en', 'th', 'vi'].includes(nav) ? nav : 'ko';
}

/** 언어를 고른다 — 저장하고 <html lang> 에 걸고 알린다 */
export function setOwnLang(code) {
  if (!OWN_LANGS.includes(code)) return false;
  set(LANG_KEY, code);
  if (typeof document !== 'undefined') document.documentElement.lang = code;
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(LANG_EVENT));
  return true;
}

/** 앱이 뜰 때 — Weglot 을 껐으면 시작 언어를 <html lang> 에 건다(켜 있으면 Weglot 이 한다) */
export function applyInitialOwnLang() {
  if (!isWeglotOff() || typeof document === 'undefined') return;
  document.documentElement.lang = initialOwnLang();
}
